// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".kpi[data-v-00dc49fe] {\n  right: auto;\n  float: right;\n  margin: -88px;\n  margin-right: 25px;\n}\n.apply-btn[data-v-00dc49fe] {\n  margin-top: 18px;\n  margin-right: 2px;\n}\n.export-dates[data-v-00dc49fe] {\n  display: flex;\n  flex-wrap: wrap;\n}\n.critical-filter-fix[data-v-00dc49fe] {\n  position: absolute;\n  left: 450px;\n  top: 84px;\n  z-index: 10;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
